<template>
    <div class = "ui-select flex flex-col full-width">
        <div class="content font-s flex flex-center-cz padding-left-m padding-right-m flex-space-between " @click="select">
            <div class="selected flex flex-center-cz ">{{text}} </div>
            <div class="menu-down margin-top-s pointer" ></div>
        </div>
        <div v-if="show" class="position-relative" >
            <div class="list flex flex-col font-s scroll">
                <div v-for="(item,index) in data" :key="index"
                :class="{'active': item.value == val, 'no-acitve': item.value != val}"
                class="flex flex-center-cz item cannotselect pointer"                 
                @click="selectItem(item.value)" >{{item.text}}</div>
            </div>
        </div>
    </div>
</template>

<script>
     export default {
        name:"Select",
        props:{
            data:{},
            value:{},
            result:{}
        },
        model: {
            prop: "value",
            event: "change"
        },
        watch:{
            value:{
                handler(newValue) {
                    console.log("newValue", newValue);
                    this.val = newValue;
                    this.text = this.getText(newValue);
                },
                immediate: true,
                deep: true   //深度监听                
            }
        },
        data() {
            return {
                val:null,
                text:null,
                selectData:[],
                show: false,
            }
        },
        methods:{

            getText(value) {
                let result = ''
                let find = this.data.filter(b=>b.value == value);
                if (find.length > 0) {
                    result = find[0].text;
                }
                return result;
            },
            selectItem(value) {
                this.val = value;
                this.text = this.getText(value);
                this.show = false;
                this.$emit("change", this.val);
            },
            select(event) {
                event.stopPropagation();//阻止冒泡，防止触发下层点击事件
                document.addEventListener("click", this.closeList, false);// 添加监听点击事件
                this.show = !this.show;
            },
            closeList() {
                document.removeEventListener("click", this.closeList, false);//关闭监听点击事件
                this.show = false;
            }

        }
     }
</script>


// WEBPACK FOOTER //
// src/components/select/Select.vue